import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewEncapsulation, ViewChild } from '@angular/core';
import { TableMode, FormGeneratorService, TableButton, BaseModel, EntryTypes, TableEvent } from '@ngx-resource-toolkit/core';
import { FormArray, FormGroup } from '@angular/forms';
import { FactureModel } from '../models/facture.model';
import { LigneFactureModel } from '../models/ligne-facture.model';
import { FactureHelper } from '../../helpers/facture.helper';
import { DateHelper } from '../../helpers/date.helper';

@Component({
    selector: 'create-facture',
    templateUrl: './create.component.html',
    styleUrls: ['./create.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CreateFactureComponent implements OnInit, OnChanges {

    @ViewChild('modallignefacture') modallignefacture: any;
    @Input() public model: FactureModel;
    @Input() public form: FormGroup;
    public ligneFactureModel: LigneFactureModel;
    public ligneFactureForm: FormGroup;

    private indiceLigneFactureEnCoursEdition: number = -1;
    private mode: string = 'edit-facture';

    constructor(private formGenerator: FormGeneratorService) { }

// TODO Récupérer dans table habilitation FACTURE_VALIDATION IS_CREATION pour droit de validation de facture
    ngOnChanges(changes: SimpleChanges): void {
        // throw new Error("Method not implemented.");
        console.log('createfacture ngOnChanges', {model: this.model['lignesFacture'], form: this.form, changes: changes});
        // Affichage ou non des boutons Ajouter ligne et Editer ligne : non visibles lorsque la facture est validée
        // Champ paiement comptant désactivé si facture validée
        // Champ Date facture désactivée si facture validée
        let options = [];
        let listeBoutonsEditionFacture = [];
        if (!this.form.value.isValide) {
            console.log('Facture non validée');
            listeBoutonsEditionFacture = [TableButton.ADD, TableButton.EDIT];
            options = [{
                value: true,
                label: 'Paiement comptant',
            }];
            this.model.registerEntryDynamicProperty([this.mode], 'dateFacture', 'type', EntryTypes.DATE);
        } else { // Facture validée
            options = [{
                value: true,
                label: 'Paiement comptant',
                disabled: true,
            }];
            this.model.registerEntryDynamicProperty([this.mode], 'dateFacture', 'type', EntryTypes.STATIC);
            // tslint:disable-next-line:max-line-length
            this.model.registerEntryDynamicProperty([this.mode], 'dateFacture', 'transform', (value) => DateHelper.timestampToDefault(value) );
        }
        console.log('listeBoutonsEditionFacture', listeBoutonsEditionFacture);
        this.model.registerEntryDynamicProperty([this.mode], 'lignesFacture', 'buttons', listeBoutonsEditionFacture);
        this.model.registerEntryDynamicProperty([this.mode], 'isPaiementComptant', 'options', options);
        this.registerSurModelFacture();
    }

    private registerSurModelFacture() {
        this.model.registerEntryDynamicProperty([this.mode], 'lignesFacture', 'actionCallback', (action: TableButton, event: TableEvent, form: FormGroup) => {
            console.log('actionCallback', action, event, form);
            const row = form.value.lignesFacture[event.rowIndex]; // event.row;
            this.indiceLigneFactureEnCoursEdition = event.rowIndex;
            switch (action) {
                case TableButton.EDIT:
                    console.log('edit callback !!', action, event, form);
                    console.log('model et form global', this.model, this.form);
                    this.ligneFactureModel = new LigneFactureModel(row);
                    this.ligneFactureModel.registerEntryDynamicProperty(['edit'], 'sens', 'type', (this.ligneFactureModel.isManuel ? EntryTypes.RADIO : EntryTypes.STATIC));

                    this.ligneFactureForm = this.formGenerator.createFormGroup(this.ligneFactureModel, 'edit');
                    console.log('model', this.ligneFactureModel);
                    console.log('form', this.ligneFactureForm);
                    this.modallignefacture.open();
                    this.gereFormulaireLigneFature(row);
                    // this.ligneFactureModel.registerEntryDynamicProperty(['edit'], );
                    break;
                case TableButton.CONSULT:
                    console.log('consult callback !!', action, row, form);
                    break;
                case TableButton.DELETE:
                    console.log('delete callback !!', action, row, form);
                    break;
                default:
                    console.log('default callback', action, row, form);
                    break;
            }
          });
    }
    ngOnInit(): void {
    }

    gereFormulaireLigneFature(factureLigne: LigneFactureModel): void {
        console.log('gereFormulaireLigneFature', factureLigne);
        // Modification du libellé autorisé uniqyuement si c'est une ligne de type manuel (créé par l'utilisateur)
        if (factureLigne.typeLigne === 'M') {
            this.ligneFactureModel.registerEntryDynamicProperty(['edit'], 'libelle', 'type', EntryTypes.TEXT);
        } else {
            this.ligneFactureModel.registerEntryDynamicProperty(['edit'], 'libelle', 'type', EntryTypes.STATIC);
        }
    }

    private calculeMontantLigneFacture(ligneFacture: LigneFactureModel): void {
        ligneFacture.montantFinal = ligneFacture.montantTarifBase * ligneFacture.taux;
    }

    deleteLigneFacture(): void {
        // Attention, voir si on a le droit de la supprimer...
        const ligneASupprimer = this.ligneFactureForm.value;
        console.log('deleteLigneFacture (todo)', { ligneASupprimer });
        if (ligneASupprimer.id) {
            // la ligne existe en BDD => il faudra la supprimer
            // this.factureForm.controls['removedLignesFacture'].value
            this.form.controls['removedLignesFacture'].value.push(ligneASupprimer);
        } else {
            // La ligne n'existe pas en BDD, il suffit de la retirer de la liste
        }
        this.form.controls['lignesFacture'].value.splice(this.indiceLigneFactureEnCoursEdition, 1);
        // this.form.controls['lignesFacture'].patchValue(lignesFactures);
        // this.model.lignesFacture.splice(this.indiceLigneFactureEnCoursEdition, 1);
        // (<FormArray>this.form.get('lignesFacture')).patchValue(this.model.lignesFacture);
        this.indiceLigneFactureEnCoursEdition = -1;

        this.model = new FactureModel(this.form.value);
        this.model.lignesFacture[this.indiceLigneFactureEnCoursEdition] = new LigneFactureModel(this.ligneFactureForm.value);


        // this.model = new FactureModel(this.form.value);
        console.log({ form: this.form, model: this.model });
        this.modallignefacture.close();

        // this.registerSurModelFacture();
    }
    valideLigneFacture(): void {
        // console.log('valideLigneFacture', this.form);
        // Map ligne facture in famille facture list
        this.model = new FactureModel(this.form.value);
        this.model.lignesFacture[this.indiceLigneFactureEnCoursEdition] = new LigneFactureModel(this.ligneFactureForm.value);
        // console.log(this.ligneFactureModel.getProperties('edit'), this.model.getProperties(this.mode));
        // On le calcule mais on ne s'en sert pas : const montantTotal = FactureHelper.calculMontantFacture(this.model);
        // console.log('apres aclcul montant facture', montantTotal, this.model);

        // this.form = this.formGenerator.createFormGroup(this.model, this.mode);
        (<FormArray>this.form.get('lignesFacture')).at(
            this.indiceLigneFactureEnCoursEdition)
            .patchValue(this.model.lignesFacture[this.indiceLigneFactureEnCoursEdition]
        );
        this.modallignefacture.close();
        this.registerSurModelFacture();
    }

    /*openEditLigneFacture(event: TableEvent) {
        console.log('openEditFacture', event);
    //    this.isModalCreate = false;
    //    event.row.idFamille = this.familleId || event.row.idFamille;
    //    event.row.familleNom = this.familleNom || event.row.familleNom;
    //    this.factureModel = new FactureModel(event.row);
    //    this.factureForm = this.formGenerator.createFormGroup(this.factureModel, this.mode);

        this.modallignefacture.open();
        // console.log('ListFactureComponent', 'factureModel', this.factureModel, this.factureForm);
      }*/
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/facture/create/create.component.ts